export const INPUT_MAX_LENGTH = 70;

export const validations = {
  required: { value: true, message: 'Campo requerido' },
  maxLength: {
    value: INPUT_MAX_LENGTH,
    message: `Máximo ${INPUT_MAX_LENGTH} caracteres`,
  },
};

export const COUNTRIES = [
  { value: 'PE', label: 'Perú' },
  { value: 'AR', label: 'Argentina' },
  { value: 'MX', label: 'México' },
  { value: 'CO', label: 'Colombia' },
  { value: 'ES', label: 'España' },
  { value: 'CL', label: 'Chile' },
  { value: '*', label: 'Otros' },
];
